export const PILL_COLORS = {
  blue: 'bg-pl-blue-600',
  green: 'bg-pl-green-600',
  red: 'bg-pl-red-600',
  rose: 'bg-pl-rose-500',
  yellow: 'bg-pl-yellow-600',
  softGold: 'bg-pl-yellow-100',
  default: 'bg-pl-blue-900',
} as const;

export const PILL_TEXT_COLORS = {
  blue: 'text-white',
  green: 'text-white',
  red: 'text-white',
  rose: 'text-white',
  yellow: 'text-pl-gray-900',
  softGold: 'text-pl-yellow-800',
  default: 'text-white',
} as const;
